
export enum TradeType {
    EQUITY = "EQUITY",
    OPTION = "OPTION"
}